export default "__VITE_ASSET__BoP0IMJG__"